<template>
  <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true" :showModalLoading="showModalLoading" :pathResource="pathResource" @refresh="onRefresh">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaIva">
        <b-icon icon="plus"></b-icon>
        Nuovo
      </b-button>
    </template>
    <!-- <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Descrizione</label>
            <b-form-select v-model="filtro.descrizioneIva" :value="null">
              <template #first>
                <b-form-select-option :value="null"> - Tutte - </b-form-select-option>
              </template>
              <b-form-select-option v-for="tipoDoc in contabilitaTipoDocumentoOptions" :key="tipoDoc.id" :value="tipoDoc.id"> {{ tipoDoc.descrizioneTipoDocumento }} ({{ tipoDoc.denominazioneStruttura }}-{{ tipoDoc.codiceStruttura }}) </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
            <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template> -->
    <template slot="table-body">
      <configurazione-contabilita-tabella-iva-list-component @edit="onEditRigaIva" ref="cmpConfigurazioneContabilitaTabellaIvaListComponent" />
      <!-- <configurazione-contabilita-causali-tipo-documenti-list-component ref="cmpConfigurazioneContabilitaCausaliTipoDocumentiListComponent" @editCausaleDocumento="onEditCausaleDocumento"></configurazione-contabilita-causali-tipo-documenti-list-component> -->
      <configurazione-contabilita-tabella-iva-edit-modal-component @afterSave="onAfterSave" ref="cmpConfigurazioneContabilitaTabellaIvaEditModalComponent" />
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import ConfigurazioneContabilitaTabellaIvaListComponent from "../components/ConfigurazioneContabilitaTabellaIvaListComponent.vue";
import ConfigurazioneContabilitaTabellaIvaEditModalComponent from "../components/ConfigurazioneContabilitaTabellaIvaEditModalComponent.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";

export default {
  mixins: [StruttureMixin, ContabilitaMixin],
  components: { SaPageLayout, ConfigurazioneContabilitaTabellaIvaListComponent, ConfigurazioneContabilitaTabellaIvaEditModalComponent },
  data() {
    return {
      showModalLoading: false,
      pathResource: null,
      strutturaOptions: [],
      linkConfigurazioni: "/configurazionecontabilita",
      //   filtro: { codiceStruttura: null, idTipoDocumento: null },
    };
  },
  mounted() {
    this.contabilitaTabellaIvaLoadData();
  },
  methods: {
    onClickNuovaIva() {
      let me = this;
      me.$refs.cmpConfigurazioneContabilitaTabellaIvaEditModalComponent.show({ id: null });
    },
    onAfterSave() {
      this.onRefresh();
    },
    onRefresh() {
      //list
      this.$refs.cmpConfigurazioneContabilitaTabellaIvaListComponent.loadData();
    },

    onEditRigaIva(item) {
      let me = this;
      console.log(item.aliquotaIva);

      me.$refs.cmpConfigurazioneContabilitaTabellaIvaEditModalComponent.show(item);
    },
    // loadDataFilter() {
    //   let sessionStorage = window.sessionStorage;
    //   sessionStorage.setItem("filtroTipiDocumentoCausali", JSON.stringify(this.filtro));
    //   this.$refs.cmpConfigurazioneContabilitaTabellaIvaListComponent.loadData();
    // },
    // onInputStrutture(v) {
    //   console.log(v);
    // },
    // onReset() {
    //   this.filtro.idTipoDocumento = null;
    //   this.loadDataFilter();
    // },
    //     onSubmit() {
    //   this.loadDataFilter();
    // },
  },
};
</script>

<style></style>
